import React from 'react';
import useTestimonials from '../../hooks/useTestimonials';
import TestimonialForm from './TestimonialForm';

const TestimonialList: React.FC = () => {
  const { testimonials, loading, error } = useTestimonials(true);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-10">
        <div data-testid="loading-spinner" className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-black"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="border-2 border-black text-black px-4 py-3">
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-black text-center mb-16 text-black">Client Testimonials</h2>

        {testimonials.length > 0 ? (
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 mb-16">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="bg-white p-8 border-2 border-black">
                <div className="flex items-center mb-4">
                  {testimonial.rating && (
                    <div className="flex mr-2">
                      {[...Array(5)].map((_, i) => (
                        <span
                          key={i}
                          className={`text-lg ${i < testimonial.rating! ? 'text-black' : 'text-gray-300'}`}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                <blockquote className="italic text-gray-700 mb-6 leading-relaxed">
                  "{testimonial.content}"
                </blockquote>

                <div className="flex items-center">
                  <div>
                    <div className="font-bold text-black">{testimonial.name}</div>
                    {testimonial.role && (
                      <div className="text-sm text-gray-600">{testimonial.role}</div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center mb-12">
            <p className="text-gray-600">No testimonials yet. Be the first to leave one!</p>
          </div>
        )}

        <div className="max-w-2xl mx-auto">
          <div className="bg-light p-8 border-2 border-black">
            <h3 className="text-2xl font-bold mb-6 text-black">Share Your Experience</h3>
            <TestimonialForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialList;